module.exports = __webpack_public_path__ + "media/images/avatar-a207394be5cd14e6b6aaa297db840639.svg";